import { SectionLanding } from '@/components/home/SectionLanding';
import { WithDefaultLayout } from '../components/DefautLayout';
import { Title } from '../components/Title';
import { Page } from '../types/Page';
import { SectionFaq } from '@/components/home/SectionFaq';
import { SectionAlumni } from '@/components/home/SectionAlumni';
import { SectionAboutOurCompany } from '@/components/home/SectionAboutOurCompany';
import { SectionWhyStudyInAccelist } from '@/components/home/SectionWhyStudyInAccelist';
import { SectionOurHoldingPartners } from '@/components/home/SectionOurHoldingPartners';
import { SectionTestimony } from '@/components/home/SectionTestimony';
import { SectionDocumentation } from '@/components/home/SectionDocumentation';
import { SectionChooseProgram } from '@/components/home/SectionChooseProgram';
import { SectionWorkshopProcedure } from '@/components/home/SectionWorkshopProcedure';
// import {ScheduleProgramNew } from '@/components/home/ScheduleProgramNew';

const IndexPage: Page = () => {
    return (
        <div>
            <Title title={'Home'} description={'Belajar coding di Accelist Edukasi Indonesia dengan jadwal fleksibel, murah, dan berkualitas. Yuk daftar sekarang!'} />
            <SectionLanding />
            <SectionAlumni />
            <SectionAboutOurCompany />
            <SectionChooseProgram />
            {/* <ScheduleProgramNew/> */}
            <SectionWorkshopProcedure />
            <SectionWhyStudyInAccelist />
            <SectionDocumentation />
            <SectionTestimony />
            <SectionOurHoldingPartners scrollSpeed={0.3} />
            <SectionFaq />
        </div>
    );
};

IndexPage.layout = WithDefaultLayout;
export default IndexPage;
